import { Injectable } from "@angular/core";
import { AuthStoreService } from "./auth-store.service";
import { ApplicantInfoStoreService } from "./applicant-info-store.service";
import { AgentApplicationStoreService } from "./agent-application-store.service";
import { CountryListStoreService } from "./country-list-store.service";
import { LanguageListStoreService } from "./language-list-store.service";
import { PersonalInfoStoreService } from "./personal-info-store.service";
import { ProgramListStoreService } from "./program-list-store.service";
import { SharedStoreService } from "./shared-store.service";
import { EnglishProficiencyStoreService } from "./english-proficiency-store.service";
import { InfoReleaseStoreService } from "./info-release-store.service";
import { UploadStoreService } from "./upload-store.service";
import { ProgramChoiceStoreService } from "./program-choice-store.service";
import { AcademicInfoStoreService } from "./academic-info-store.service";
import { PaymentStoreService } from "./payment-store.service";
@Injectable({
  providedIn: "root",
})
/*
  Store bundle
*/
export class StoreService {
  constructor(
    public authStore: AuthStoreService,
    public applicantInfoStore: ApplicantInfoStoreService,
    public agentApplicationStore: AgentApplicationStoreService,
    public countryListStore: CountryListStoreService,
    public languageListStore: LanguageListStoreService,
    public personalInfoStore: PersonalInfoStoreService,
    public programListStore: ProgramListStoreService,
    public sharedStore: SharedStoreService,
    public englishProficiencyStore: EnglishProficiencyStoreService,
    public infoReleaseStore: InfoReleaseStoreService,
    public uploadStore: UploadStoreService,
    public programChoiceStore: ProgramChoiceStoreService,
    public academicInfoStore: AcademicInfoStoreService,
    public paymentStore: PaymentStoreService
  ) {}
}
